<template>
    <div class="modal-body-message-content">
        <app-normal-block-text2 class="mb-1" :text="date"></app-normal-block-text2>
        <app-normal-block-text class="mb-0" :text="description"></app-normal-block-text>
    </div>
</template>

<script>
    export default {
        props: {
            date: String,
            description: String
        }
    }
</script>

<style lang="sass" scoped>
    .modal-body-message-content
        padding: 4px 16px 14px 16px
        border-radius: 6px
        background-color: rgba(0, 0, 0, 0.06)
</style>